import { TiledGameObject } from "src/games/shared/phaserHelpers/HandyTypes";

export class GroceryItem extends Phaser.GameObjects.Sprite {
    id: number;
    bagged: boolean;
    scanned: boolean;

    constructor(scene: Phaser.Scene, ob: TiledGameObject) {
        var id = ob.properties[0].value;
        super(scene, ob.x + ob.width / 2, ob.y + ob.height / 2, "assets", "item" + id);
        this.id = id;
        this.bagged = false;
        this.scanned = false;
        this.type = "Pet";

        this.setDepth(5);
        this.setInteractive({ useHandCursor: true });
        this.scene.input.setDraggable(this);

        this.scene.add.existing(this);
    }

}



// WEBPACK FOOTER //
// ./src/games/GroceryBaggerGame/objects/GroceryItem.ts